import React, {useEffect, useState} from 'react'
import {useAuthClient} from '../utils/use-auth-client'

const CheckStatus = () => {
  const client = useAuthClient()
  const [data, setData] = useState({status: 'Loading...', timestamp_gmt: ''})

  useEffect(() => {
    async function fetchStatus() {
      try {
        const result = await client('check-status')
        setData(result)
      } catch (error) {
        setData({status: 'Error fetching status', timestamp_gmt: ''})
      }
    }

    fetchStatus()
  }, [client])

  return (
    <div>
      <p>{data.status}</p>
      <p>{data.timestamp_gmt}</p>
    </div>
  )
}

export default CheckStatus
